import { AdminMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenu";

export { AdminMenu };
